import * as AuthContext from './AuthContext';

export default AuthContext;
